import { Builder } from '../api/builder'
import { RequirementResource } from '../api/config'

export const viewDemandList = Builder(filters => RequirementResource().get('/list', {params: filters}))
export const viewDemandDetail = Builder(id => RequirementResource().get('/detail', {params: {id: id}}))
export const viewMyReceives = Builder(filters => RequirementResource().get('/receive', {params: filters}))
export const viewReceive = Builder(id => RequirementResource().get('/beforereceive', {params: {id: id}}))
export const receiveDemand = Builder(id => RequirementResource().post('/receive', {id: id}))
export const revokeDemand = Builder(info => RequirementResource().post('/revoke', info))
export const contactDemand = Builder(id => RequirementResource().get('/contact', {params: {id: id}}))
export const countDemand = Builder(() => RequirementResource().get('/index'))
export const feedbackDemand = Builder(info => RequirementResource().post('/feedback', info))